import { CompanySearchResult } from '@/types'
import { useQuery } from '@tanstack/react-query'
import axios from 'axios'

export function useCompanySearch({ organizationSlug, query }: { organizationSlug: string; query: string }) {
  return useQuery({
    queryKey: ['company_searches', organizationSlug, query],
    queryFn: () =>
      axios
        .get<CompanySearchResult[]>('/internal_api/company_searches', {
          params: { organization_slug: organizationSlug, query },
        })
        .then((response) => response.data),
    enabled: query.trim().length >= 3,
  })
}
